export enum CouponTypes {
    FLAT = 'FLAT',
    PERCENT = 'PERCENT'
}